import moment from "moment";

/**
 * Formats a timestamp (in milliseconds) as a date string (YYYY-MM-DD)
 * @param {number|string} ms - Timestamp in milliseconds
 * @returns {string} Formatted date string or "--" if invalid
 */
export function formatDate(ms) {
  const n = Number(ms);
  if (!n) return "--";
  const m = moment(n);
  return m.isValid() ? m.format("YYYY-MM-DD") : "--";
}

